module.exports = __webpack_public_path__ + "static/media/img1.0c5fa827.png";